import React, { useState } from "preact/compat";
import { CompareListProps } from './compareList.type';
import { BooksItem } from "../../../💠Molecules/Sportsbook/BookItem/BooksItem";
import { AffLink } from "../../../💎Atoms/AffLink/AffLink";

export const CompareList: React.FunctionComponent<CompareListProps> = ({
    t,
    site,
    view,
    comparisonBets,
    bet
}) => {
    const [showMore, setShowMore] = useState(false);
  
    const toggleShowMore = () => {
        setShowMore(!showMore);
    }

    return (
        <div className="partner-list-container d-flex flex-column">
            {comparisonBets ?
                <div>
                    <div className="h6 fs-7">{t.books_list.heading}</div>
                    <div>
                        <div className="d-flex justity-justify-content-lg-around align-items-stretch mb-1 mb-lg-2">
                            <div className="col-3 pe-0"></div>
                            <div className={`col-9 py-2 ${view === 'parlay' ? 'ps-2' : 'ps-0'} pe-2 d-flex justify-content-start align-items-start`}>
                                <div className={`col-4 text-capitalize fw-bold text-gray ${view === 'parlay' ? 'text-start' : ''} ${site === 'covers' ? 'fs-8' : 'fs-9'}`}>{view === 'parlay' ? t.books_list.table_col_parlay : t.books_list.table_col_straight}</div>
                                <div className={`col-7 ps-2 text-capitalize text-start fw-bold text-gray ${site === 'covers' ? 'fs-8' : 'fs-9'}`}>{t.books_list.table_col_2}</div>
                            </div>
                        </div>

                        {comparisonBets ?
                            comparisonBets?.length > 4 ?
                            <div>
                                {comparisonBets.slice(0, 4).map((partner: any, index: number) => {
                                    return (
                                        partner?.sportsbookVm.sportsbookClickout ?
                                            <AffLink 
                                                className="d-block p-0"
                                                site={site}
                                                url={partner?.sportsbookVm.sportsbookClickout}
                                                aalink={`${partner?.sportsbookVm.providerBookId !== null && partner?.sportsbookVm.providerBookId !== '' ? 'bet-slip-compare-books-sign-up-logo-click' : 'bet-slip-compare-books-logo-click'}`}
                                                type="link">
                                                    <BooksItem 
                                                        className={`${index === 0 ? 'border-success active' : 'border-light'}`} 
                                                        site={site}
                                                        key={index} 
                                                        sortedComparisonList={partner} 
                                                        wager={view === 'straight' ? bet : null} 
                                                        odds={view === 'parlay' ? bet !== -1 ? partner.odds : null : null} />
                                            </AffLink>
                                        : 
                                            <BooksItem 
                                                className={`${index === 0 ? 'border-success active' : 'border-light'}`} 
                                                site={site}
                                                key={index} 
                                                sortedComparisonList={partner} 
                                                wager={view === 'straight' ? bet : null} 
                                                odds={view === 'parlay' ? bet !== -1 ? partner.odds : null : null} />
                                    )
                                })}
                                <div className={`${showMore ? 'd-block' : 'd-none'}`}>
                                    {comparisonBets.slice(4).map((partner: any, index: number) => {
                                        return (
                                            partner?.sportsbookVm.sportsbookClickout ?
                                            <AffLink 
                                                className="d-block p-0"
                                                site={site}
                                                url={partner?.sportsbookVm.sportsbookClickout}
                                                aalink={`${partner?.sportsbookVm.providerBookId !== null && partner?.sportsbookVm.providerBookId !== '' ? 'bet-slip-compare-books-sign-up-logo-click' : 'bet-slip-compare-books-logo-click'}`}
                                                type="link">
                                                    <BooksItem 
                                                        className={`border-light`} 
                                                        site={site}
                                                        key={index} 
                                                        sortedComparisonList={partner} 
                                                        wager={view === 'straight' ? bet : null} 
                                                        odds={view === 'parlay' ? bet !== -1 ? partner.odds : null : null} />
                                                </AffLink>
                                            : 
                                                <BooksItem 
                                                    className={`border-light`} 
                                                    site={site}
                                                    key={index} 
                                                    sortedComparisonList={partner} 
                                                    wager={view === 'straight' ? bet : null} 
                                                    odds={view === 'parlay' ? bet !== -1 ? partner.odds : null : null} />
                                        )
                                    })}
                                </div>
                                <div role="button" className="d-flex justify-content-between align-items-center rounded bg-light px-3 py-2" onClick={toggleShowMore}>
                                    <span className="fs-8 fw-bold">{showMore ? t.books_list.compare_less : t.books_list.compare_more}</span>
                                    <div className={`d-flex ${showMore ? 'mat-rotate-180' : ''}`}><i class={`mat-icon-circle_angle`}></i> <span class='visually-hidden'>circle icon to open and close</span></div>
                                </div>
                            </div>
                        : 
                            comparisonBets?.map((partner: any, index: number) => {
                                return (
                                    partner?.sportsbookVm.sportsbookClickout ?
                                        <AffLink 
                                            className="d-block p-0"
                                            site={site}
                                            url={partner?.sportsbookVm.sportsbookClickout}
                                            aalink={`${partner?.sportsbookVm.providerBookId !== null && partner?.sportsbookVm.providerBookId !== '' ? 'bet-slip-compare-books-sign-up-logo-click' : 'bet-slip-compare-books-logo-click'}`}
                                            type="link">
                                                <BooksItem 
                                                    className={`${index === 0 ? 'border-success active' : 'border-light' }`} 
                                                    site={site}
                                                    key={index} 
                                                    sortedComparisonList={partner} 
                                                    wager={view === 'straight' ? bet : null} 
                                                    odds={view === 'parlay' ? bet !== -1 ? partner.odds : null : null} />
                                        </AffLink>
                                    : 
                                        <BooksItem 
                                            className={`${index === 0 ? 'border-success active' : 'border-light'}`} 
                                            site={site}
                                            key={index} 
                                            sortedComparisonList={partner} 
                                            wager={view === 'straight' ? bet : null} 
                                            odds={view === 'parlay' ? bet !== -1 ? partner.odds : null : null} />
                                )
                            })
                        : ''
                        }
                    </div>
                    <div className={`${site ==="covers" ? 'fs-8' : 'fs-9'} fw-normal text-gray pt-1`}>{t.books_list.disclaimer}</div>
                </div>
            : '' }
        </div>
    )
};